import { render, staticRenderFns } from "./PromotionReview.vue?vue&type=template&id=450274d4&"
import script from "./PromotionReview.vue?vue&type=script&lang=js&"
export * from "./PromotionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports